import { lighten, styled } from '@mui/material'
import List from '@mui/material/List'

export const ListContainer = styled(List)(({ theme }) => ({
  '&& .Mui-selected, && .Mui-selected:hover': {
    backgroundColor:
      theme.palette.mode === 'light'
        ? lighten(theme.palette.primary.main, 0.9)
        : lighten(theme.palette.background.paper, 0.105),
    '.MuiListItemIcon-root': {
      color: lighten(theme.palette.primary.main, 0.01)
    },
    '.MuiTypography-root': {
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.primary.main
    }
  }
}))
